function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.02 15.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Giving-History"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Giving-History---Date-Dropdown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Give-Again-Arrow",
    d: "M9.84,8.23,2.66,15.41a.6.6,0,0,1-.44.18.6.6,0,0,1-.43-.18L.18,13.8A.58.58,0,0,1,0,13.37a.62.62,0,0,1,.18-.44L5.32,7.8.18,2.66A.6.6,0,0,1,0,2.22a.6.6,0,0,1,.18-.43L1.79.18A.6.6,0,0,1,2.22,0a.6.6,0,0,1,.44.18L9.84,7.36A.6.6,0,0,1,10,7.8.6.6,0,0,1,9.84,8.23Z",
    style: {
      fill: "#2774ae"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.9a19089bc96936d6b1a43b0b16678cea.svg";
export { ForwardRef as ReactComponent };